import React from "react";
import { Grid, IconButton } from "e100-react-components";
import { useStyles } from "./styles";

interface TitleProps {
  title: any;
  onClose?: () => void;
}

export const Title = ({ title, onClose }: TitleProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      justify="space-between"
      classes={{ root: classes.container }}
    >
      <Grid item xs={12}>
        {title}
      </Grid>
      {
        onClose && (
          <Grid item>
            <IconButton
              kind={'close'}
              onClick={onClose}
            />
          </Grid>
        )
      }
    </Grid>
  );
};
